<template>
    <div class="column q-gutter-y-sm" style="margin-right: 15px">
        <div class="text-weight-bold">{{ params.label }}</div>
        <div v-for="(o, i) in options" :key="i">
            <q-radio v-show="!isSent" :label="o" :model-value="optionIndex === i" :val="true" @click="clickRadio(i)" />
            <div v-show="isSent" class="row q-gutter-x-md">
                <div :class="{ 'text-weight-bold': +optionIndex === i }" style="width: 35px;">
                    {{ resultPercents[i] }}%
                </div>
                <div class="col">
                    <div v-show="+optionIndex === i" class="text-weight-bold">{{ o }}</div>
                    <div v-show="+optionIndex !== i">{{ o }}</div>
                    <q-linear-progress :value="resultPercents[i] / 100" dark />
                    <q-linear-progress v-show="+resultPercents[i] === 0" :value="0.01" dark />
                </div>
            </div>
        </div>
        <div v-show="totalVotes" class="text-caption">
            {{ getVotesCount() }}
        </div>
        <DefaultButton v-show="inited && !this.isSent" label="Проголосовать" @click="send" :loading="loading" />
    </div>
</template>

<script>
import uiControlMixin from 'src/mixins/ui/uiControlMixin';
import DefaultButton from 'components/ui/common/DefaultButton';

export default {
    name: 'Poll',
    components: { DefaultButton },
    mixins: [uiControlMixin],
    mounted () {
        this.init();
    },
    data () {
        return {
            loading: false,
            inited: false,
            isSent: false,
            options: [],
            resultPercents: [],
            optionIndex: undefined,
            totalVotes: undefined,
        };
    },
    methods: {
        init () {
            this.loading = true;
            this.isSent = false;
            const { user } = this.$store.state.pages;
            this.loading = true;
            if (this.view.options) {
                this.options = this.view.options.split('\n');
                this.resultPercents = new Array(this.options.length).fill(0);
            }
            this.$db.users.getUserPoll(user.id, this.page.id, this.view.id).then((poll) => {
                if (poll && poll.option_index) {
                    this.optionIndex = poll.option_index;
                    this.isSent = true;
                }
                this.loadStats();
            });
        },
        send () {
            if (!this.optionIndex && this.optionIndex !== 0) {
                this.$q.notify('Выберите один вариант');
                return;
            }
            const { user } = this.$store.state.pages;
            this.loading = true;
            const pageTitle = this.page.title;
            const { label } = this.params;
            const optionLabel = this.options[this.optionIndex];

            const payload = {
                user_id: user.id,
                page_id: this.page.id,
                poll_id: this.view.id,
                option_index: this.optionIndex,
                option_label: optionLabel,
                page_title: pageTitle,
                poll_title: label,
            };
            if (!this.totalVotes) { this.totalVotes = 0; }
            this.totalVotes += 1;
            this.$db.users.sendUserPoll(payload).then(() => {
                this.isSent = true;
                this.loading = false;
                this.$q.notify('Спасибо за Ваш голос!');
                this.loadStats();
            });
        },
        clickRadio (index) {
            this.optionIndex = index;
        },
        loadStats () {
            this.$db.users.getPollStats(this.page.id, this.view.id).then((stats) => {
                const votes = new Array(this.options.length).fill(0);
                for (let i = 0; i < stats.length; i += 1) {
                    const row = stats[i];
                    votes[row.option_index] += 1;
                }
                const totalVotes = stats.length;

                for (let i = 0; i < votes.length; i += 1) {
                    votes[i] = ((votes[i] * 100) / totalVotes).toFixed(1);
                }
                this.resultPercents = votes;
                this.totalVotes = totalVotes;
                this.loading = false;
                this.inited = true;
            });
        },
        getVotesCount () {
            if (!this.totalVotes) {
                return undefined;
            }
            const i = +this.totalVotes % 20;
            let w = 'голосов';
            if (i === 1) { w = 'голос'; }
            if (i >= 2 && i < 5) { w = 'голоса'; }

            return `${this.totalVotes} ${w}`;
        },
    },
};
</script>

<style scoped>
    .input {
        background-color: white;
        border-radius: 25px;
        padding: 0 10px 0 10px;
    }

</style>
